var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.08335 16.1779H6.66669C3.33335 16.1779 1.66669 15.3446 1.66669 11.1779V7.01123C1.66669 3.6779 3.33335 2.01123 6.66669 2.01123H13.3334C16.6667 2.01123 18.3334 3.6779 18.3334 7.01123V11.1779C18.3334 14.5112 16.6667 16.1779 13.3334 16.1779H12.9167C12.6584 16.1779 12.4084 16.3029 12.25 16.5112L11 18.1779C10.45 18.9112 9.55002 18.9112 9.00002 18.1779L7.75002 16.5112C7.61669 16.3279 7.30835 16.1779 7.08335 16.1779Z",
    stroke: "#269ACF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3304 9.51115H13.3378",
    stroke: "#269ACF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99626 9.51115H10.0037",
    stroke: "#269ACF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66209 9.51115H6.66957",
    stroke: "#269ACF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSms);
export default __webpack_public_path__ + "static/media/sms.bde9e4fab0584ffc53093be437357a36.svg";
export { ForwardRef as ReactComponent };